export default {
  chartType: "heatmap",
  showTitle: true,
  showControls: true,
  showQuery: true,
  showColor: true,
  showSortZ: true,
  showSortX: true,
  showSortY: true,
  showNormalize: true,
  showRecency: true,
  showSize: true,
  showMetric: false,
  showMetricX: false,
  showMetricY: false,
  showTypeCats: false
};
